type SegmentAnalyticsClient = {
  track?: (eventName: string, properties?: Record<string, unknown>) => void;
};

declare global {
  interface Window {
    analytics?: SegmentAnalyticsClient;
  }
}

const getSegmentAnalyticsClient = (): SegmentAnalyticsClient | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const client = window.analytics;
  if (!client || typeof client.track !== 'function') {
    return null;
  }

  return client;
};

export const isSegmentTrackingEnabled = (): boolean => Boolean(getSegmentAnalyticsClient());

export const trackSegmentEvent = (
  eventName: string,
  properties?: Record<string, unknown>
): boolean => {
  const client = getSegmentAnalyticsClient();
  if (!client) {
    return false;
  }

  try {
    client.track?.(eventName, properties);
    return true;
  } catch (error) {
    console.warn('Failed to emit analytics event', {
      eventName,
      error,
    });
    return false;
  }
};

export interface CampaignSelectionAnalyticsPayload extends Record<string, unknown> {
  campaignId: string;
  triggeredAt: string;
  selectionType?: 'manual' | 'reset';
  source?: string;
  isAllCampaigns?: boolean;
}

const CAMPAIGN_SELECTION_EVENT_NAME = 'engagement.campaignSelection.changed';

export const trackCampaignSelectionChanged = (
  payload: CampaignSelectionAnalyticsPayload
): boolean => trackSegmentEvent(CAMPAIGN_SELECTION_EVENT_NAME, payload);
